import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from 'element-ui'
Vue.use(VueRouter);
// 顶部加载动画实现
import NProress from "nprogress";
import "nprogress/nprogress.css";
NProress.configure({ showSpinner: false });
// 引入组件
import task from "./modules/task";
import template from "./modules/template";
import comprehensive from "./modules/comprehensive";
const routes = [{
        path: "/",
        name: "Login",
        component: () =>
            import ("@/views/Login.vue"),
        meta: { title: "登录" },
    },
    {
        path: "/index",
        name: "index",
        component: () =>
            import ("@/layout/index.vue"),
        meta: [
            { title: "任务管理", path: "/index/task/allTask", name: "task" },
            {
                title: "模板管理",
                path: "/index/template/formatTemplate",
                name: "template",
            },
            {
                title: "综合设置",
                path: "/index/Comprehensive/Comprehensive",
                name: "Comprehensive",
            },
        ],
        children: [task, template, comprehensive],
    },
    {
        path: "/test",
        name: "test",
        component: () =>
            import ("@/views/test/test.vue"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach(async(to, from, next) => {
    NProress.start();
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.fullPath == "/") {
        next();
    } else {
        if (window.localStorage.getItem("loginType")) {
            next();
        } else {
            Message.error("您的登录已过期")
            next("/");
        }
    }


});
router.afterEach(() => {
    NProress.done();
});
export default router;